var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.143,
    height: 21.321,
    viewBox: "0 0 22.143 21.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45358",
    "data-name": "Group 45358",
    transform: "translate(8381.74 4305.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79780",
    "data-name": "Path 79780",
    d: "M20.618,14.865a.7.7,0,0,0-.7.7V19.6a.812.812,0,0,1-.81.811H2.216a.812.812,0,0,1-.81-.811V15.568a.7.7,0,0,0-1.406,0V19.6a2.219,2.219,0,0,0,2.216,2.217H19.1A2.22,2.22,0,0,0,21.321,19.6V15.568a.7.7,0,0,0-.7-.7",
    transform: "translate(-8359.927 -4305.426) rotate(90)",
    fill: "#ecf0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79781",
    "data-name": "Path 79781",
    d: "M10.5,16.872a.7.7,0,0,0,.995,0l4.96-4.96a.7.7,0,0,0-.995-.994L11.7,14.677V.7A.7.7,0,0,0,10.29.7V14.677L6.531,10.918a.7.7,0,0,0-.995.994Z",
    transform: "translate(-8376.676 -4283.772) rotate(-90)",
    fill: "#ecf0f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1e952bf2d75094adf5eba6893f284d88.svg";
export { ForwardRef as ReactComponent };